export default {"src":"/_next/static/media/undraw_book.1377256d.svg","height":512,"width":669,"blurWidth":0,"blurHeight":0};